import TSXComponent from '@/utils/tsx-component';
import Component from 'vue-class-component';
import { RadioGroup, RadioTag } from '@ohu-mobile/core';
import { fieldMixin } from '@ohu-mobile/core/lib/Form/fieldMixin';
import { Model, Watch } from 'vue-property-decorator';
import './index.scss';

export const subjects = ['语文', '数学', '英语', '思政', '历史', '地理', '物理', '化学', '生物', '技术'];

export interface RankSelectProps {
  rankValues?: string[];
}

export interface RankSelectEvents {
  onChange: string[];
}

@Component({
  name: 'rank-select',
  mixins: [ fieldMixin('internalValue', 'value') ],
})
export default class RankSelect extends TSXComponent<RankSelectProps, RankSelectEvents> {
  @Model('change' , { type: Array, default: () => [] })
  public value!: string[];

  public internalValue!: string[];

  @Watch('value')
  public valuesChange(value: string[]) {
    this.internalValue = [...value];
  }

  public handleChange(value: any, index: number) {
    this.$set(this.internalValue, index, value);
    if (this.internalValue.length === 10) {
      this.$emit('change', this.internalValue);
    }
  }

  public render() {
    return (
      <div class="rank-select">
        {
          subjects.map((subject, index) => (
            <div class="rank-select-item">
              <div class="rank-select-item__name">{subject}</div>
              <RadioGroup name={index.toString()}
                value={this.internalValue[index]}
                class="rank-select-item__content"
                onChange={(value: any) => this.handleChange(value, index)}>
                <RadioTag value="A">A</RadioTag>
                <RadioTag value="B">B</RadioTag>
                <RadioTag value="C">C</RadioTag>
                <RadioTag value="D">D</RadioTag>
              </RadioGroup>
            </div>
          ))
        }
      </div>
    );
  }
}
